import { useEffect, useState } from 'react'
import esriId from '@arcgis/core/identity/IdentityManager'
import { useGetEsriTokenQuery } from 'app/services/api/esri'

const useEsriAuth = () => {
  const { data: esriAccessToken } = useGetEsriTokenQuery()
  const [isEsriTokenSetupComplete, setIsEsriTokenSetupComplete] =
    useState(false)

  useEffect(() => {
    const ARC_SERVER = import.meta.env.LH_TIMP_ARC_SERVER as string

    if (esriAccessToken != null) {
      esriId.registerToken({
        server: `${ARC_SERVER}/server/rest/services`,
        token: esriAccessToken
      })
      setIsEsriTokenSetupComplete(true)
    }
  }, [esriAccessToken])

  return { isEsriTokenSetupComplete }
}

export { useEsriAuth }
